import Vue from "vue";
import Channel from "@/scripts/_channel.js";

let _request = (url, data, method, opts, onSuccess, onError) => {
	let request;

	if (Channel.bearerToken !== null) Vue.http.headers.common["Authorization"] = "Bearer " + Channel.bearerToken;
	if (method === "GET") request = Vue.http.get(url, opts);
	else if (method === "PUT") request = Vue.http.put(url, data, opts);
	else if (method === "POST") request = Vue.http.post(url, data, opts);
	else if (method === "DELETE") request = Vue.http.delete(url, opts);

	let _executeCallback = function (callback, response) {
		if (callback !== null) callback(response.body);
	};

	request.then(
		response => {
			_executeCallback(onSuccess, response);
		},
		response => {
			if (onError && response.status === 401) onError(response);
			else _executeCallback(onError, response);
		}
	);
};

// To adjust this value for development: copy the `.env` file then rename it to `.env.local` and adjust the values.
const _host_tocc = process.env.VUE_APP_HOST_TOCC;

let _dbApi = (command, data, method, onSuccess, onError) => {
	//
	var _baseUrl = `${_host_tocc}deutschebahn`;
	var url = _baseUrl + command;

	//
	_request(url, data, method, null, onSuccess, onError);
};


export default {
	request: _request,
	dbApi: _dbApi,
	get(command, onSuccess) {
		var url = _host_tocc + command;
		this.request(url, null, "GET", null, onSuccess);
	},
	post(command, data, onSuccess) {
		const url = _host_tocc + command;
		this.request(url, data, "POST", null, onSuccess);
	},
	delete(command, onSuccess) {
		const url = _host_tocc + command;
		this.request(url, null, "DELETE", null, onSuccess);
	}
};